import { render, staticRenderFns } from "./submitButton.vue?vue&type=template&id=45085b72&scoped=true"
import script from "./submitButton.vue?vue&type=script&lang=js"
export * from "./submitButton.vue?vue&type=script&lang=js"
import style0 from "./submitButton.vue?vue&type=style&index=0&id=45085b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45085b72",
  null
  
)

export default component.exports